"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypePlugin = void 0;
var TypePlugin;
(function (TypePlugin) {
    /**
     * 플러그인을 열어요
     * @required remote 리모트 웹 주소
     * @required height 높이 (px)
     * 또는
     * @required app    로컬 웹뷰 주소
     * @required path   로컬 웹뷰 내 경로 (HashRouter)
     * @required height 높이 (px)
     */
    TypePlugin["ReqPluginOpen"] = "REQ.PLUGIN.OPEN";
    /**
     * 플러그인을 닫아요
     */
    TypePlugin["ReqPluginClose"] = "REQ.PLUGIN.CLOSE";
    /**
     * 현재 열려있는 플러그인의 스타일을 변경해요
     * @optional height 높이 (px)
     */
    TypePlugin["ReqPluginStyle"] = "REQ.PLUGIN.STYLE";
})(TypePlugin = exports.TypePlugin || (exports.TypePlugin = {}));
//# sourceMappingURL=Plugin.js.map